<template>
  <div id="app" class="container-fluid">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
body {
  background-color: #f5f6fa;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 5px;
}
.common {
  color: #ffffff;
  background-color: #00C3E0;
}
.container-fluid{
  padding-right: 5px;
  padding-left: 0px;
}
.contens {
  background-color:#ffffff;
}
</style>
